import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import type { Product } from '@/types';
import Button from './Button';

interface ProductCardProps {
  product: Product;
  onAddToCart: (product: Product) => void;
}

export default function ProductCard({ product, onAddToCart }: ProductCardProps) {
  const isPremium = product.id.includes('premium');

  return (
    <motion.div
      className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300"
      whileHover={{ scale: 1.02 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
    >
      {/* Imagen del producto con fondo apropiado */}
      <div className={`relative aspect-[3/4] overflow-hidden ${isPremium ? 'bg-slate-50' : 'bg-stone-50'}`}>
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500 p-4"
        />
        {/* Badge de variedad */}
        <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold text-white ${
          isPremium ? 'bg-blue-600' : 'bg-amber-700'
        }`}>
          {isPremium ? 'Premium' : 'Tradicional'}
        </div>
      </div>

      <div className="p-5">
        <h3 className="font-display text-lg text-coffee-900 mb-2">{product.name}</h3>
        <p className="text-sm text-coffee-700 leading-relaxed mb-4 line-clamp-3">
          {product.description}
        </p>
        <Button
          variant="primary"
          size="sm"
          className="w-full"
          leftIcon={<ShoppingCart className="w-4 h-4" />}
          onClick={() => onAddToCart(product)}
        >
          Agregar al pedido
        </Button>
      </div>
    </motion.div>
  );
}
